import React, { useEffect, useState } from 'react';
import { AddressValues, Zone } from 'appAPITypes';
import {
  AppMap,
  AppMapMarker,
  AppMapPolygon,
} from 'primitives/maps/appMapElements';

import { ShCountryConfigs } from '@shoootin/config';

const useFitBounds = (
  map: google.maps.Map | null,
  zones: Zone[],
  address: AddressValues,
) => {
  useEffect(() => {
    if (map) {
      const customExtends = (
        bounds: google.maps.LatLngBounds,
        latitude: number,
        longitude: number,
      ): void => {
        const delta = 0.01;
        bounds.extend(
          new google.maps.LatLng(latitude - delta, longitude - delta),
        );
        bounds.extend(
          new google.maps.LatLng(latitude + delta, longitude + delta),
        );
      };

      const bounds = new google.maps.LatLngBounds();
      //we keep initial address of user
      if (address.latitude && address.longitude) {
        customExtends(bounds, address.latitude, address.longitude);
      }
      //we add each zones polygons latLng
      zones.forEach(zone => {
        const path = google.maps.geometry.encoding.decodePath(zone.encodedLine);
        path.forEach(each => {
          customExtends(bounds, each.lat(), each.lng());
        });
      });
      if (!bounds.isEmpty()) {
        map.fitBounds(bounds);
      }
    }
  }, [map, zones, address.latitude, address.longitude]);
};

const PhotographerMap = ({
  address,
  zones,
  onMapClick,
  onZonePolygonClick,
}: {
  address: AddressValues;
  zones: Zone[];
  onMapClick: (event: google.maps.MouseEvent) => void;
  onZonePolygonClick: (zone: Zone, index: number) => void;
}) => {
  const [map, setMap] = useState<google.maps.Map | null>(null);

  useFitBounds(map, zones, address);

  const getMapCenterCoordinates = () => {
    if (address.longitude && address.longitude) {
      return {
        lat: address.latitude!,
        lng: address.longitude!,
      };
    } else {
      return ShCountryConfigs[address.country].centerLatLng;
    }
  };
  const getDefaultZoom = () => {
    if (map && address.longitude && address.longitude) {
      return map.getZoom();
    } else {
      return ShCountryConfigs[address.country].zoom;
    }
  };

  return (
    <AppMap
      onLoad={map => {
        setMap(map);
      }}
      zoom={getDefaultZoom()}
      center={getMapCenterCoordinates()}
      onClick={event => {
        onMapClick(event);
      }}
    >
      {address.latitude && address.longitude && (
        <AppMapMarker
          position={{
            lat: address.latitude,
            lng: address.longitude,
          }}
        />
      )}

      {zones.map((zone, index) => {
        const path = google.maps.geometry.encoding.decodePath(zone.encodedLine);
        return (
          <AppMapPolygon
            key={zone.id}
            paths={path}
            onClick={() => {
              onZonePolygonClick(zone, index);
            }}
          />
        );
      })}
    </AppMap>
  );
};

export default PhotographerMap;
